import { NgModule } from '@angular/core';
import { ClickOutsideDirective } from './click-outside.directive';
import { DndDirective } from './dnd.directive';
import { StopClickPropagationDirective } from './stop-click-propagation.directive';
import { ResizeYDirective } from './resizeY.directive';
import { ResizeDirective } from './resize.directive';
import { DynamicTextColorDirective } from './dynamic-text-color.directive';
import { TimeInputDirective } from './timeInput.directive';
import { DragScrollDirective } from './drag-scroll.directive';
import { NumberInputNoScrollDirective } from './number-input-no-scroll.directive';
import { ShowPlaceholderIfDirective } from './show-placeholder-if.directive';
import { FeatureFlagDirective } from './feature-flag.directive';

const DIRECTIVES = [
  ClickOutsideDirective,
  DndDirective,
  StopClickPropagationDirective,
  ResizeYDirective,
  ResizeDirective,
  DynamicTextColorDirective,
  TimeInputDirective,
  DragScrollDirective,
  NumberInputNoScrollDirective,
  ShowPlaceholderIfDirective,
  FeatureFlagDirective,
];

@NgModule({
  imports: [],
  declarations: [DIRECTIVES],
  exports: [DIRECTIVES],
})
export class SharedUtilsDirectivesModule {}
